// Ce qu'il faut savoir d'un emplacement pour sa fiche de tour (décision 50) : modèle d'inventaire,
// référence de comparaison (décision 40) et séjour en cours, en simple information (décision 4).

import { fetchAccommodations, fetchStaysForPitch, fetchLastPitchInventory } from './fieldApi'
import { findAccommodation, modelThemes } from './fieldModel'
import { buildReference } from './fieldReference'
import { isCurrentStay } from './fieldStays'

// Modèles d'hébergement gardés le temps de la session
let accommodationsCache = null

// { accommodationId, themes, reference, currentStay } ; themes vide : pas de modèle, inspection seule
export function loadPitchContext(pitch, now)
{
	const accommodations = accommodationsCache ? Promise.resolve(accommodationsCache) : fetchAccommodations()
	return Promise.all([accommodations, fetchStaysForPitch(pitch.location).catch(() => [])])
		.then(([list, stays]) => {
			accommodationsCache = list
			const accommodation = findAccommodation(list, pitch.location_category || '')
			const themes = modelThemes(accommodation)
			const currentStay = stays.find(stay => stay.status !== 'canceled' && isCurrentStay(stay, now)) || null
			const base = { accommodationId: accommodation ? accommodation._id || null : null, themes, reference: null, currentStay }
			if (themes.length === 0)
				return base
			return fetchLastPitchInventory(pitch.location)
				.then(last => ({ ...base, reference: buildReference(themes, last) }))
		})
}

// Ligne sous « Rien à signaler » quand il enregistre un inventaire identique à la référence
export function sameAsReferenceLabel(reference, formatDate)
{
	if (reference && reference.source === 'inventory')
		return 'Tout est comme au dernier inventaire, du ' + formatDate(reference.time)
	return 'Tout est conforme au modèle'
}
